import { itemSubmitRetractionResponse } from "~/store/graphql/mutations/itemSubmitRetractionResponse.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const submitConfirmRetraction = async function ({ commit, state }) {
  const id = state.retractionItem.id;
  const message = state.retractionItem.retraction.response.message;

  const data = await runGraphQLQuery(
    itemSubmitRetractionResponse,
    {
      id,
      message,
      retractionStatus: "ACCEPTED",
    },
    this.$axios
  );

  if (data) {
    commit("SET_RETRACTION_UPDATE", data);

    return Promise.resolve(data);
  }
};

export default submitConfirmRetraction;
